import classes from "./ComplexityDot.module.css";

export default function ComplexityDot({status}) {
    return (
        <div
            className={`${classes.dot} ${status === 1 ? classes.easy : status === 2 ? classes.medium : classes.hard}`}/>
    )
}